import { render, staticRenderFns } from "./HandlingExpansionPanelContent.vue?vue&type=template&id=263e9d51&scoped=true"
import script from "./HandlingExpansionPanelContent.vue?vue&type=script&lang=js"
export * from "./HandlingExpansionPanelContent.vue?vue&type=script&lang=js"
import style0 from "./HandlingExpansionPanelContent.vue?vue&type=style&index=0&id=263e9d51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263e9d51",
  null
  
)

export default component.exports